import React, { useState } from "react";
import { alpha, useTheme } from "@mui/material/styles";
import { isEmpty } from "lodash";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Legend,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { getColocacionSemanalAsync } from "../../../api/Dashboard";
import { formatearMonto } from "../../../helpers/formato";
import {
  escalasGrafico,
  formatearMontoCompacto,
  paletaGraficos,
  pluginsGrafico,
  descripcionGrafico,
} from "../../../theme/graficos";
import { useDatoPanel } from "../useDatoPanel";
import SeccionPanel from "../SeccionPanel";
import { sumar } from "../panel";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Legend,
  Tooltip
);

const DIAS = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];

// Fecha corta del eje: día de la semana y número ("lun 29").
const diaCorto = (fecha) => {
  const f = new Date(fecha);
  return `${DIAS[f.getDay()]} ${f.getDate()}`;
};

const ColocacionSemanal = () => {
  const [labels, setLabels] = useState([]);
  const [colocacion, setColocacion] = useState([]);
  const paleta = paletaGraficos(useTheme());

  const { cargando, error, recargar } = useDatoPanel(
    getColocacionSemanalAsync,
    (respuesta) => {
      // El servicio entrega los días de hoy hacia atrás: el eje va del más antiguo al más reciente.
      const items = [...respuesta.result].sort(
        (a, b) => new Date(a.fecha) - new Date(b.fecha)
      );

      setLabels(items.map((item) => diaCorto(item.fecha)));
      setColocacion(items.map((item) => item.colocacion));
    }
  );

  const graphicData = {
    labels: labels,
    datasets: [
      {
        label: "Colocación",
        data: colocacion,
        borderColor: paleta.primario,
        backgroundColor: alpha(paleta.primario, 0.12),
        fill: true,
        pointStyle: "circle",
        pointRadius: 5,
        pointHoverRadius: 7,
        pointBackgroundColor: paleta.superficie,
        pointBorderColor: paleta.primario,
        pointBorderWidth: 2,
        tension: 0.3,
      },
    ],
  };

  // La colocación son córdobas (el backend suma MontoEntregado en C$): C$, no USD.
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: pluginsGrafico(paleta, {
      etiqueta: (context) =>
        context.parsed.y !== null
          ? `${context.dataset.label}: ${formatearMonto(context.parsed.y)}`
          : "",
    }),
    elements: {
      line: {
        borderJoinStyle: "round",
      },
    },
    scales: escalasGrafico(paleta, formatearMontoCompacto),
  };

  return (
    <SeccionPanel
      titulo="Colocación semanal"
      resumen={`Total ${formatearMonto(sumar(colocacion))}`}
      cargando={cargando}
      error={error}
      vacio={isEmpty(labels)}
      descripcionVacio="Aquí se muestra lo desembolsado en los últimos días hábiles."
      onReintentar={recargar}
      altura={{ xs: 260, md: 300 }}
    >
      <Line
        options={options}
        data={graphicData}
        aria-label={descripcionGrafico("Colocación semanal", graphicData, formatearMonto)}
      />
    </SeccionPanel>
  );
};

export default ColocacionSemanal;
